import React from 'react';
import CrossRoad from "../UI/Crossroad";
import { tracksColors } from "../../config/styles";

const Crossroad_13ARed_13CRed = () => <CrossRoad coords="1884.000000, 1184.000000" color={tracksColors.red}/>;

export default Crossroad_13ARed_13CRed;
